import "../../Assets/scss/pages/manage-alt-text.scss";
import { addDefaultImgSrc } from "../../Helpers/addDefaultImgSrc";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import DashboardPagesTemplate from "../../Template/DashboardPagesTemplate";
import DashboardPageTitle from "../../Components/InnerPageTitle";
import { Badge, Button, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useEffect, useMemo, useRef, useState } from "react";
import ShowRecordItem from "../../Components/ShowRecordItem";
import PaginationComponent from "../../Components/Pagination";
import { ManageImageAltTableCell } from "../../Components/ManageImageAltTableCell";
import { ImageAltListPropTypes, SelectedImageAltListPropTypes } from "../../PropTypes/ImageAltPropTypes";
import { AllUpdateImageAltTextService, getAllImageAltTextService } from "../../Services/ImageAltTextService";
import { debounce } from "lodash";
import NoRecordFound from "../../Components/NoRecordFound";
import InitMsgBlock from "../../Components/InitMsgBlock";
import FreeVersionOverlay from "../../Components/FreeVersionOverlay";


// component to render image alt text remediation page
const ImageAltTextRemediationPage = () => {

  // Function
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { pageID } = useParams();

  // Redux
  const { currentWebsite, accessToken, currentWebsitePlanStatus, isLoading } = useSelector((store: StoreProptypes) => store);

  // State
  //const [altImageAPIRecall, setAltImageAPIRecall] = useState<boolean>(false);


  const [originalImgObj, setOriginalImgObj] = useState<SelectedImageAltListPropTypes[]>([]);
  const [renderImgObj, setRenderImgObj] = useState<SelectedImageAltListPropTypes[]>([]);
  const [selectedAltImgObj, setSelectedAltImgObj] = useState<SelectedImageAltListPropTypes[]>([]);
  const [imageAltErrorPopupObj, setImageAltErrorPopupObj] = useState<SelectedImageAltListPropTypes[]>([])

  //const [totalRecord, setTotalRecord] = useState<number>(0);
  const [filterValue, setFilterValue] = useState("1");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [offset, setOffset] = useState<number>(0);

  const [isCheckAll, setIsCheckAll] = useState<boolean>(false);

  const [showFreeWidgetStrip, setShowFreeWidgetStrip] = useState(false);

  const [totalMissingAltRecord, setTotalMissingAltRecord] = useState<number>();
  const [totalUpdateAltRecord, setTotalUpdateAltRecord] = useState<number>();
  const [totalDecorativeAltRecord, setTotalDecorativeAltRecord] = useState<number>();
  const [totalOtherRecord, setTotalOtherRecord] = useState<number>();
  const [allImageListRecord, setAllImageListRecord] = useState<number>(0);

  useEffect(() => {

    // check if current website is available
    if (currentWebsite) {

      setTotalMissingAltRecord(currentWebsite.total_missing_alt_tag)
      setTotalUpdateAltRecord(currentWebsite.total_update_alt_text)
      setTotalDecorativeAltRecord(currentWebsite.total_decorative_images)
      setTotalOtherRecord(currentWebsite.total_other_images)

      // check if filter value is 1, then set missing alt text record as total record
      if (filterValue === "1") {
        setAllImageListRecord(currentWebsite.total_missing_alt_tag);
      }
      // check if filter value is 3, then set updated alt text record as total record
      else if (filterValue === "3") {
        setAllImageListRecord(currentWebsite.total_update_alt_text);
      }
      // check if filter value is 4, then set decorative images record as total record
      else if (filterValue === "4") {
        setAllImageListRecord(currentWebsite.total_decorative_images);
      }
      // check if filter value is 5, then set other images record as total record
      else if (filterValue === "5") {
        setAllImageListRecord(currentWebsite.total_other_images);
      }
      else {
        setAllImageListRecord(0);
      }
    }
  }, [currentWebsite, filterValue])

  const [imageAltErrorPopup, setImageAltErrorPopup] = useState(false);

  const terms = ""
  const sortByValue = "1";
  const prevLimitRef = useRef<number>(10);
  const prevFilterValueRef = useRef<string>('1');

  // For Free Widget
  useEffect(() => {
    if (currentWebsite) {
      // check if current package information is available and its a free widget
      if (currentWebsite && currentWebsite.current_package_only && currentWebsite.current_package_only.length > 0) {
        if (currentWebsite.current_package_only[0].is_free_widget === 1) {
          setShowFreeWidgetStrip(true);
        } else {
          setShowFreeWidgetStrip(false);
        }
      }
    }
  }, [currentWebsite]);

  // Filter Value
  useEffect(() => {
    setRenderImgObj([]);
    setSelectedAltImgObj([]);
    setImageAltErrorPopupObj([]);
    setOffset(0);
  }, [filterValue]);

  // Pagination
  useEffect(() => {
    setCurrentPage(1);
  }, [limit, filterValue]);

  useEffect(() => {
    setOffset(currentPage * limit - limit);
  }, [currentPage]);

  // Get Main List
  useEffect(() => {
    // check if access token, current website are available and limit and filter values are not changed
    if (accessToken && currentWebsite && (limit === prevLimitRef.current) && (filterValue === prevFilterValueRef.current)) {
      // service to get all images with filters
      getAllImageAltTextService(
        accessToken,
        currentWebsite.id,
        offset,
        limit,
        terms,
        filterValue,
        sortByValue,
        dispatch,
        t,
        setOriginalImgObj,
      );

    }
  }, [offset, currentWebsite, pageID]);

  useEffect(() => {
    // check if limit and filter value are unchanged and offset is 0
    if (((limit !== prevLimitRef.current) || (filterValue !== prevFilterValueRef.current)) && (offset === 0)) {
      // check if access token and current website exists
      if (accessToken && currentWebsite) {
        // get images with filters
        getAllImageAltTextService(
          accessToken,
          currentWebsite.id,
          offset,
          limit,
          terms,
          filterValue,
          sortByValue,
          dispatch,
          t,
          setOriginalImgObj,
        );
      }
      prevLimitRef.current = limit;
      prevFilterValueRef.current = filterValue;
    }
  }, [offset, limit, filterValue]);



  // Function to check difference between two arrays
  const checkDifference = (
    selectedAltImgObj: SelectedImageAltListPropTypes[], // array of selected images
    renderImgObj: SelectedImageAltListPropTypes[] // array of rendered images
  ) => {
    const tempArray = renderImgObj.filter((originalItem) => {
      return !selectedAltImgObj.some((item) => originalItem.id === item.id);
    });
    return tempArray;
  };

  // Function to merge two arrays
  const mergeArray = (
    A: SelectedImageAltListPropTypes[], // Images array 1
    B: SelectedImageAltListPropTypes[] // Images array 2
  ) => {
    const tempArray = checkDifference(A, B);
    let mergedArray = [...A, ...tempArray];
    return mergedArray;
  };

  // function to remove B array items from A array
  const popArray = (
    A: SelectedImageAltListPropTypes[], // Images array
    B: SelectedImageAltListPropTypes[] // Images array
  ) => {
    const tempArray = A.filter((item) => {
      return !B.some((Bitem) => item.id === Bitem.id);
    });
    return tempArray;
  };

  // Copy Array
  useEffect(() => {
    // check if original image array is available
    if (originalImgObj) {

      const tempImageAltTextListObj = originalImgObj.map((item) => {
        // check if filter value is 1 (filter by missing alt text)
        if (filterValue === "1") {
          const tempObj = {
            ...item,
            is_selected: selectedAltImgObj.some(selectedItem => selectedItem.id === item.id) ? 1 : 0,
            is_updated_from: item.ai_generated_text ? 2 : 1,
            temp_alt_text_updated: item.ai_generated_text ? item.ai_generated_text : item.alt_text,
          };
          return tempObj;
        } else {
          const tempObj = {
            ...item,
            is_selected: selectedAltImgObj.some(selectedItem => selectedItem.id === item.id) ? 1 : 0,
          };
          return tempObj;
        }
      });
      // set filtered images array for render
      tempImageAltTextListObj && setRenderImgObj(tempImageAltTextListObj);
    } else {
      // render original image array
      setRenderImgObj(originalImgObj);
    }
  }, [originalImgObj]);

  // Set Check all
  useEffect(() => {
    // check if rendered image array is not empty
    if (renderImgObj.length > 0) {

      // check if selected images array is different than rendered images array
      if (checkDifference(selectedAltImgObj, renderImgObj).length) {
        setIsCheckAll(false);
      } else {
        setIsCheckAll(true);
      }
    } else {
      setIsCheckAll(false);
    }
  }, [renderImgObj]);

  // function to handle check all
  const HandleCheckAll = (e: React.ChangeEvent<HTMLInputElement>) => {

    let handleCheckFlag = e.target.checked;

    // check if check all flag is enabled
    if (handleCheckFlag) {

      let tempCheckAllSelectedObj = renderImgObj.map((item) => {
        const tempObj = {
          ...item,
          is_selected: 1,
        }
        return tempObj;
      });
      setSelectedAltImgObj(mergeArray(selectedAltImgObj, tempCheckAllSelectedObj));
    } else {
      setRenderImgObj(originalImgObj);
      setSelectedAltImgObj(popArray(selectedAltImgObj, renderImgObj));
    }
  }

  useEffect(() => {
    // check if selected images array exists
    if (selectedAltImgObj) {
      const tempImageAltTextListObj = renderImgObj.map((item) => {
        // check if filter value is 1 (filter by missing alt text)
        if (filterValue === "1") {
          const tempObj = {
            ...item,
            is_selected: selectedAltImgObj.some(selectedItem => selectedItem.id === item.id) ? 1 : 0,
            is_updated_from: item.ai_generated_text ? 2 : 1,
            temp_alt_text_updated: item.ai_generated_text
              ? item.ai_generated_text
              : item.alt_text,
          };
          return tempObj;
        } else {
          const tempObj = {
            ...item,
            is_selected: selectedAltImgObj.some(selectedItem => selectedItem.id === item.id) ? 1 : 0,            
          };
          return tempObj;
        }
      });      

      tempImageAltTextListObj && setRenderImgObj(tempImageAltTextListObj);
    }
  }, [selectedAltImgObj])

  // function to handle individual selection
  const individualCheck = (
    item: SelectedImageAltListPropTypes, // image object
    flag: boolean // flag to select or deselect
  ) => {
    // check if selection flag is true
    if (flag) {
      setSelectedAltImgObj(mergeArray(selectedAltImgObj, [{ ...item, is_selected: 1 }]));
    } else {

      setSelectedAltImgObj(popArray(selectedAltImgObj, [item]));

      const findOriElement = originalImgObj.filter(oriObj => oriObj.id === item.id).map(oriFilterObj => {
        return oriFilterObj;
      });


      let tempCheckAllSelectedObj = renderImgObj.map((renderItem) => {
        if (renderItem.id === item.id) {
          return findOriElement[0];
        } else {
          return renderItem
        }
      });

      setRenderImgObj(tempCheckAllSelectedObj);
    }
  };

  // function to handle Decorative Switch
  const decorativeImageSwitch = (
    decorativeItem: SelectedImageAltListPropTypes, // image object
    flag: boolean, // flag to mark as decorative
    newAltText?: string // text string if it was set as new alt text
  ) => {

    // check if rendered images array exist
    if (renderImgObj) {

      const tempImageAltTextListObj1 = renderImgObj.map((item) => {
        let tempObj = item;

        // check if Id matches to mark/un-mark as decorative
        if (decorativeItem.id === item.id) {
          // check if decorative flag
          if (flag) {
            tempObj = {
              ...item,
              is_decorative: 1,
            };
          } else {
            tempObj = {
              ...item,
              temp_alt_text_updated: newAltText ? newAltText : "",
              is_decorative: 0,
            };
          }
        }

        return tempObj;
      });

      setRenderImgObj([...tempImageAltTextListObj1]);


      // check if image's ID exists on selected images array
      if (selectedAltImgObj.some((item) => item.id === decorativeItem.id)) {

        let compareOriginalArraysObj = originalImgObj.filter(item => item.id === decorativeItem.id);

        const swichCondition = !!compareOriginalArraysObj[0].is_decorative === flag;
        const oriTextCondition = ((compareOriginalArraysObj[0].alt_text) === decorativeItem.alt_text);
        const updateTextCondition = compareOriginalArraysObj[0].alt_text_updated === decorativeItem.alt_text_updated;


        const oriTextWithNewTextCondition = (newAltText ? (compareOriginalArraysObj[0].alt_text === newAltText) : false);
        const updateTextWithNewTextCondition = (compareOriginalArraysObj[0].alt_text_updated ? (compareOriginalArraysObj[0].alt_text_updated) === newAltText : false);

        const tab1Condition = ((compareOriginalArraysObj[0].alt_text) === decorativeItem.temp_alt_text_updated);

        let finalCondition;

        // check if filter by other images
        if (filterValue === '5') {
          // check if edit box is opened for image object
          if (decorativeItem.is_open_textarea) {
            finalCondition = swichCondition && oriTextCondition && oriTextWithNewTextCondition;
          } else {
            finalCondition = swichCondition;
          }

        }

        // check if filter by updated alt text
        if (filterValue === '3') {
          // check if edit box is opened for image object
          if (decorativeItem.is_open_textarea) {
            finalCondition = swichCondition && oriTextCondition && updateTextCondition && updateTextWithNewTextCondition;
          } else {
            finalCondition = swichCondition;
          }

        }

        // check if filter by decorative images
        if (filterValue === '4') {
          finalCondition = swichCondition;
        }

        // check if filter value is 1 (filter by missing alt text)
        if (filterValue === '1') {

          // check if updated alt text and new image alt text are blank
          if ((decorativeItem.temp_alt_text_updated === '') && newAltText === '') {
            finalCondition = swichCondition && tab1Condition;
          } else {
            finalCondition = swichCondition;
          }

        }

        // check if final applicable condition exists
        if (finalCondition) {

          const removeSelectedTempImageAltTextObj = selectedAltImgObj.filter(filterItem => filterItem.id === decorativeItem.id).map((item) => {
            let tempObj = item;
            if (flag) {
              tempObj = {
                ...item,
                is_decorative: 1,
                is_selected: 0,
              };
            } else {
              tempObj = {
                ...item,
                temp_alt_text_updated: newAltText ? newAltText : "",
                is_decorative: 0,
                is_selected: 0,
                is_open_textarea: 0
              };
            }
            return tempObj;
          });

          setSelectedAltImgObj(popArray(selectedAltImgObj, removeSelectedTempImageAltTextObj));

        } else {
          const selectedTempImageAltTextListObj = selectedAltImgObj.map((item) => {
            let tempObj = item;
            if (decorativeItem.id === item.id) {
              if (flag) {
                tempObj = {
                  ...item,
                  is_decorative: 1,
                  is_selected: 1,
                };
              } else {
                tempObj = {
                  ...item,
                  temp_alt_text_updated: newAltText ? newAltText : "",
                  is_decorative: 0,
                  is_selected: 1,
                };
              }
            }
            return tempObj;
          });
          setSelectedAltImgObj([...selectedTempImageAltTextListObj]);
        }

      } else {

        let selectedTempImgObj = renderImgObj.filter((item) => item.id === decorativeItem.id).map((mapItem) => {
          let tempObj = mapItem;

          // check if id matches
          if (decorativeItem.id === mapItem.id) {
            // check if decorative flag is set
            if (flag) {
              tempObj = {
                ...mapItem,
                is_decorative: 1,
                is_selected: 1,
              };
            } else {
              tempObj = {
                ...mapItem,
                temp_alt_text_updated: newAltText ? newAltText : "",
                is_decorative: 0,
                is_selected: 1,
              };
            }
          }

          return tempObj;

        });

        setSelectedAltImgObj([...selectedAltImgObj, ...selectedTempImgObj]);

      }

    }

  };

  // function to throttle function call on user input
  const debouncedUpdateAltTextHandler = useMemo(() => {
    return debounce(decorativeImageSwitch, 500);
  }, [renderImgObj]);

  // function to handle copy
  const HandleCopyText = (
    id: number, // object Id
    text: string, // text to copy
    radioType: number | null // flag to determine from where the text is updated. 0 = not updated, 1 = user input, 2 = AI generated.
  ) => {

    // check if rendered image array exists
    if (renderImgObj) {

      const tempImageAltTextListObj2 = renderImgObj.map((item) => {
        let tempObj = item;

        // check if Id matches, then update object
        if (id === item.id) {
          if (text) {

            tempObj = {
              ...item,
              temp_alt_text_updated: text,
              is_selected: 1,
              is_updated_from: radioType ? radioType : 0,
              is_open_textarea: 1,
            };
          }
        }
        return tempObj;
      });

      setRenderImgObj([...tempImageAltTextListObj2]);

      // check if image exists on selected images array
      if (selectedAltImgObj.some((item) => item.id === id)) {
        const selectedTempImageAltTextListObj = selectedAltImgObj.map((item) => {
          let tempObj = item;

          // check if Id matches, then update object
          if (id === item.id) {
            if (text) {
              tempObj = {
                ...item,
                temp_alt_text_updated: text,
                is_selected: 1,
                is_updated_from: radioType ? radioType : 0,
                is_open_textarea: 1,
              };
            }
          }
          return tempObj;
        });

        setSelectedAltImgObj([...selectedTempImageAltTextListObj]);

      } else {

        let selectedTempImgObj = renderImgObj.filter((item) => item.id === id).map((mapItem) => {
          let tempObj = mapItem;

          // check if Id matches, then update object
          if (id === mapItem.id) {
            // check if text exists to copy
            if (text) {
              tempObj = {
                ...mapItem,
                temp_alt_text_updated: text,
                is_selected: 1,
                is_updated_from: radioType ? radioType : 0,
                is_open_textarea: 1,
              };
            } else {
              // check if filter value is 1 (filter by missing alt text)
              if (filterValue === '1') {
                tempObj = {
                  ...mapItem,
                  temp_alt_text_updated: '',
                  is_selected: 1,
                  is_updated_from: 0,
                  is_open_textarea: 0,
                };
              }
            }
          }
          return tempObj;
        });

        // check if filter value is 1 (filter by missing alt text)
        if (filterValue === '1') {
          setRenderImgObj(mergeArray(renderImgObj, selectedTempImgObj));
        }

        setSelectedAltImgObj([...selectedAltImgObj, ...selectedTempImgObj]);

      }

    }
  };

  // function select image when user updates alt text
  const handleSelectImgObj = (
    selectTab1Item: SelectedImageAltListPropTypes, // image object
    value: string // user inputted image alt text
  ) => {

    const selectedTempImageAltTextListObj = selectedAltImgObj.map((item) => {
      let tempObj = item;

      // if id matches, update the image object
      if (selectTab1Item.id === item.id) {
        if (value) {
          tempObj = {
            ...item,
            temp_alt_text_updated: value,
            is_selected: 1,
            is_updated_from: 0,
            is_open_textarea: 0,
          };
        }
      }
      return tempObj;
    });

    setSelectedAltImgObj([...selectedTempImageAltTextListObj]);
  }

  // function to handle focus in
  const handleSelectImgObjOnFocus = (
    objItem: SelectedImageAltListPropTypes,  // image object
    selectObjValue: string // flag of user inputted text
  ) => {
    HandleCopyText(objItem.id, selectObjValue, 0)
  }

  // function to handle focus out 
  const handleSelectImgObjOnBlur = (
    objItem: SelectedImageAltListPropTypes,  // image object
    selectObjValue: string // flag of user inputted text
  ) => {

    // check if user inputted text is empty, then remove it from selection array
    if (selectObjValue === '') {
      setSelectedAltImgObj(popArray(selectedAltImgObj, [objItem]));
    }
  }


  // Error Image Popup
  const [isShowImagePopup, setIsShowImagePopup] = useState(false);
  const [imagePopupObj, setImagePopupObj] = useState<ImageAltListPropTypes | null>();

  // function to hide error popup
  const handleImagePopupClose = () => {
    setIsShowImagePopup(false);
    setImagePopupObj(null);
  };

  // function to show error popup
  const handleImagePopupShow = (
    imageAltTextItem: ImageAltListPropTypes // image object
  ) => {
    setIsShowImagePopup(true);
    setImagePopupObj(imageAltTextItem);
  };


  // function to handle submit
  const HandleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    //console.log("handle submit");
    //console.log("selectedAltImgObj", selectedAltImgObj);
    let SelectedImgObjCheck = selectedAltImgObj.filter((SelectedImgObj) => SelectedImgObj.is_decorative === 0 && SelectedImgObj.temp_alt_text_updated === "");
    //console.log("SelectedImgObjCheck", SelectedImgObjCheck);
    //let SelectedImgObjCheck = selectedAltImgObj;

    // check if updated images array is empty
    if (SelectedImgObjCheck.length > 0) {
      SelectedImgObjCheck && setImageAltErrorPopupObj([...SelectedImgObjCheck]);
      setImageAltErrorPopup(true);

    } else {
      // check if access token, selected images array and current website is available
      if (accessToken && selectedAltImgObj && currentWebsite) {
        // service to update image alt text
        AllUpdateImageAltTextService(accessToken, currentWebsite.id, dispatch, t, selectedAltImgObj).then((res) => {
          // check if response is ok
          if (res.response.status === 200) {
            setSelectedAltImgObj([]);
            setImageAltErrorPopupObj([]);

            // check if access token and current website is available
            if (accessToken && currentWebsite) {
              // service to get updated images array
              getAllImageAltTextService(
                accessToken,
                currentWebsite.id,
                offset,
                limit,
                terms,
                filterValue,
                sortByValue,
                dispatch,
                t,
                setOriginalImgObj,
              );
            }
          }
        })
      }
    }
  };


  // Show information popup
  const [isShowInfoModal, setIsShowInfoModal] = useState<boolean>(false);
  const [infoModalType, setInfoModalType] = useState<number>(0);

  // function to show information modal
  const handleShowInfoModal = (type: number) => {
    setInfoModalType(type);
    setIsShowInfoModal(true);
  }

  // function to hide information modal
  const handleHideInfoModal = () => {
    setIsShowInfoModal(false);
    setInfoModalType(0);
  }


  return (
    <>
      <DashboardPagesTemplate>

        {console.log("selectedAltImgObj", selectedAltImgObj)}

        <DashboardPageTitle
          pageTitle={`${t("Manage Alt Text Popup Title")}`}
          subPageTitle={`For ${currentWebsite?.domain}`}
        />

        <div className={`aioa_dashboard-manage-image-alt ${(currentWebsitePlanStatus.isInit || currentWebsitePlanStatus.isFreeWidget) ? `website-init-msg` : ``}`}>

          {/* check if its a free widget, then display an overlay */}
          {(currentWebsitePlanStatus.isFreeWidget) ? (
            <>
              <FreeVersionOverlay />
            </>
          ) :
            <>
              {/* check if its a initialize flag, then display an overlay */}
              {currentWebsitePlanStatus.isInit && (
                <>
                  <InitMsgBlock />
                </>
              )}
            </>

          }

          <div className="aioa_dashboard-image-list-filter-wrapper" id="aioa_dashboard-order-list-filter">

            <div className="aioa_dashboard-image-type-list-tab">
              <ul>
                <li>
                  <Button
                    size="lg"
                    className={`${filterValue === '1' ? `active` : ``}`}
                    onClick={(e) => setFilterValue("1")}
                    role="tab"
                    aria-selected={filterValue === "1" ? true : false}
                  >
                    {t("Recommended Alt Text Based on AI")} ({totalMissingAltRecord ? totalMissingAltRecord : 0})
                  </Button></li>
                <li>
                  <Button
                    size="lg"
                    className={`${filterValue === '3' ? `active` : ``}`}
                    onClick={(e) => setFilterValue("3")}
                    role="tab"
                    aria-selected={filterValue === "3" ? true : false}
                  >
                    {t('Remediated')} ({totalUpdateAltRecord ? totalUpdateAltRecord : 0})
                  </Button>
                </li>
                <li>
                  <Button
                    size="lg"
                    className={`${filterValue === '4' ? `active` : ``}`}
                    onClick={(e) => setFilterValue("4")}
                    role="tab"
                    aria-selected={filterValue === "4" ? true : false}
                  >
                    {t('Decorative Images')} ({totalDecorativeAltRecord ? totalDecorativeAltRecord : 0})
                  </Button>
                </li>
                <li>
                  <Button
                    size="lg"
                    className={`${filterValue === '5' ? `active` : ``}`}
                    onClick={(e) => setFilterValue("5")}
                    role="tab"
                    aria-selected={filterValue === "5" ? true : false}
                  >
                    {t('Other Images')} ({totalOtherRecord ? totalOtherRecord : 0})
                  </Button>
                </li>
              </ul>
            </div>

            <div className="aioa_dashboard-image-list-filter-block-list">
              {/* <div className="aioa_dashboard-image-list-filter-block caption-text">
                <h2 className="h5 mb-0">
                  {filterValue === "1"
                    ? t("Recommended Alt Text Based on AI")
                    : filterValue === "2"
                      ? t("Images with Alt")
                      : filterValue === "3"
                        ? <>
                          <span>{t("Remediated")}</span>
                          <Button variant="link" className="info-btn" aria-label={t("Learn more about remediated alt text").toString()} onClick={() => handleShowInfoModal(2)}>
                            <i className="material-symbols-outlined" aria-hidden="true">info</i>
                          </Button>
                        </>
                        : filterValue === "4"
                          ? t("Decorative Images")
                          : t("Other Images")}
                </h2>
              </div> */}

              <div className="aioa_dashboard-image-list-filter-block">
                <Form.Label htmlFor='showPages'>{t("Items Per Page")}</Form.Label>
                <Form.Select
                  onChange={(e) => setLimit(parseInt(e.target.value))}
                  id="showPages"
                  value={limit}
                  aria-label={t("Items Per Page").toString()}
                >
                  <option value="10">{t("10")}</option>
                  <option value="20">{t("20")}</option>
                  <option value="40">{t("40")}</option>
                  <option value="80">{t("80")}</option>
                  <option value="100">{t("100")}</option>
                </Form.Select>
              </div>

              <div className="aioa_dashboard-image-list-filter-block d-sm-none">
                <Form.Check
                  className="form-check"
                  type="checkbox"
                  aria-label={t("Select all images").toString()}
                  label={t("Select all images").toString()}
                  onChange={(e) => HandleCheckAll(e)}
                  checked={isCheckAll}
                  disabled={showFreeWidgetStrip}
                />
              </div>

            </div>

          </div>

          <div className="aioa_dashboard-table">

            <div className="aioa_dashboard-table-thead">
              <div className="aioa_dashboard-table-tr">
                <div className="aioa_dashboard-table-th tcw-100 aioa_dashboard-table-cell-sidegap" aria-hidden="true">
                  <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                      <Tooltip
                        data-bs-html="true"
                        id="button-tooltip"
                      >
                        <span className="text-start">
                          {t("Select All")}
                        </span>
                      </Tooltip>
                    }
                  >
                    <Form.Check
                      className="form-check"
                      type="checkbox"
                      aria-label={t("Select all images").toString()}
                      onChange={(e) => HandleCheckAll(e)}
                      checked={isCheckAll}
                      disabled={showFreeWidgetStrip}
                    />
                  </OverlayTrigger>
                </div>
                <div className="aioa_dashboard-table-th tcw-250 text-center aioa_dashboard-table-cell-sidegap" aria-hidden="true">{t("Image")}</div>
                <div className="aioa_dashboard-table-th tcw-200 text-center aioa_dashboard-table-cell-sidegap" aria-hidden="true">
                  {t("Is Decorative?")}
                  <Button variant="link" className="info-btn" aria-label={t("Learn more about Decorative Images").toString()} onClick={() => handleShowInfoModal(3)}>
                    <i className="material-symbols-outlined" aria-hidden="true">info</i>
                  </Button>
                </div>
                <div className="aioa_dashboard-table-th tcw-auto aioa_dashboard-table-cell-sidegap" aria-hidden="true">{t("Update Alt Text")}</div>
              </div>
            </div>

            <div className="aioa_dashboard-table-body" aria-live='polite'>
              {renderImgObj ? (
                <>

                  {renderImgObj.length > 0 ? (
                    <>
                      {renderImgObj.map((renderImgObjElement) => {

                        // Selected Object Condition
                        let imageAltTextItem: SelectedImageAltListPropTypes;
                        let selectedRenderImgObj = selectedAltImgObj.find((selectedItem) => selectedItem.id === renderImgObjElement.id);
                        if (selectedRenderImgObj) {
                          imageAltTextItem = selectedRenderImgObj;
                        } else {
                          imageAltTextItem = renderImgObjElement;
                        }

                        return (
                          <ManageImageAltTableCell
                            item={renderImgObjElement} key={renderImgObjElement.id}
                            rowClass={imageAltErrorPopupObj.find((errorImgObj) => errorImgObj.id === renderImgObjElement.id) ? "error-row" : ""}
                            showFreeWidgetStrip={showFreeWidgetStrip}
                            individualCheck={individualCheck}
                            handleImagePopupShow={handleImagePopupShow}
                            decorativeImageSwitch={decorativeImageSwitch}
                            filterValue={filterValue}
                            HandleCopyText={HandleCopyText}
                            handleSelectImgObj={handleSelectImgObj}
                            handleSelectImgObjOnFocus={handleSelectImgObjOnFocus}
                            handleSelectImgObjOnBlur={handleSelectImgObjOnBlur}
                            debouncedUpdateAltTextHandler={debouncedUpdateAltTextHandler}
                          />
                        )
                      })}
                    </>
                  ) : (
                    <>
                      {filterValue === "1"
                        ? <NoRecordFound joyful={true} imageType={`img`} noRecordText={`${t('Recommended Alt Text message')}`} />
                        : filterValue === "3"
                          ? <NoRecordFound joyful={false} imageType={`img`} noRecordText={`${t('Remediated message')}`} />
                          : filterValue === "4"
                            ? <NoRecordFound joyful={false} imageType={`img`} noRecordText={`${t('Decorative Images message')}`} />
                            : <NoRecordFound joyful={false} imageType={`img`} noRecordText={`${t('Other Images message')}`} />
                      }
                    </>
                  )}
                </>
              ) : (
                <>

                </>
              )}
            </div>


            {/* Save Button */}
            {selectedAltImgObj.length > 0 && (
              <>
                <div
                  className="position-sticky bottom-0 bg-light py-3"
                  style={{ zIndex: 9 }}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <span className="me-3 ">
                      {selectedAltImgObj.length} {t("Selected Image")}
                    </span>
                    <Button
                      type="submit"
                      variant="primary"
                      size="lg"
                      onClick={(e) => HandleSubmit(e)}
                      disabled={isLoading}
                    >
                      <>
                        {t("Save")}
                      </>
                    </Button>
                  </div>
                </div>
              </>
            )}

            <div className="aioa_dashboard-table-pagination-main">
              <>
                <ShowRecordItem
                  offset={offset}
                  limit={limit}
                  totalRecord={allImageListRecord}
                />
                <PaginationComponent
                  currentPage={currentPage}
                  totalRecords={allImageListRecord}
                  itemsPerPage={limit}
                  setCurrentPage={setCurrentPage}
                />
              </>
            </div>

          </div>

          {/* Show Image Info Modal */}
          <Modal show={isShowImagePopup} onHide={handleImagePopupClose} fullscreen="sm-down" backdrop="static" centered>
            <Modal.Header closeButton>
              <Modal.Title>&nbsp;</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {imagePopupObj && (
                <>
                  <div className="alt-text-box-img">
                    <div className="text-right">
                      {imagePopupObj.is_updated_from === 2 && imagePopupObj.ai_generated_text && (
                        <Badge
                          bg="danger"
                          className="mb-2"
                          style={{ borderRadius: "0" }}
                        >
                          {t("AI Based Alt Text")}
                        </Badge>
                      )}
                      <div className="text-center">
                        <img
                          onError={addDefaultImgSrc}
                          src={imagePopupObj.image_url}
                          alt={imagePopupObj.alt_text_updated}
                        />
                      </div>
                    </div>

                    <div className="mt-3 text-start">
                      {imagePopupObj.alt_text ? (
                        <>
                          <div className="">
                            <strong>{t("Original Alt Text")}</strong> :{" "}
                            {imagePopupObj.alt_text}
                          </div>
                        </>
                      ) : (
                        <></>
                      )}

                      {imagePopupObj.ai_generated_text ? (
                        <>
                          <div className="">
                            <strong>{t("AI Alt Text")}</strong> :{" "}
                            {imagePopupObj.ai_generated_text}
                          </div>
                        </>
                      ) : (
                        <>
                        </>
                      )}

                      {imagePopupObj.alt_text_updated ? (
                        <>
                          <div className="">
                            <strong>{t("Updated Alt Text")}</strong> :{" "}
                            {imagePopupObj.alt_text_updated}
                          </div>
                        </>
                      ) : (
                        <>
                        </>
                      )}

                    </div>
                  </div>
                </>
              )}
            </Modal.Body>
          </Modal>

          {/* Show Error Info Modal */}
          <Modal show={imageAltErrorPopup} onHide={() => setImageAltErrorPopup(false)} fullscreen="sm-down" backdrop="static" centered>
            <Modal.Header closeButton>
              <Modal.Title>{t("Error Updating Alt Text Popup Title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="errorpopup-content">
                <p>{t("Error Updating Alt Text Popup Description")}</p>
              </div>
            </Modal.Body>
            <Modal.Footer >
              <Button variant="primary" size="lg" className="m-0" onClick={() => setImageAltErrorPopup(false)}>{t("Okay")}</Button>
            </Modal.Footer>
          </Modal>

          {/* Show Info Modal */}
          <Modal show={isShowInfoModal} onHide={() => handleHideInfoModal()} fullscreen="sm-down" backdrop="static" centered>
            <Modal.Header closeButton>
              <Modal.Title>
                {infoModalType === 1 ? (
                  <>

                  </>
                ) : infoModalType === 2 ? (
                  <>
                    {t("Remediated")}
                  </>
                ) : infoModalType === 3 ? (
                  <>
                    {t("About Decorative Images")}
                  </>
                ) : (
                  <>

                  </>
                )}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {infoModalType === 1 ? (
                <>

                </>
              ) : infoModalType === 2 ? (
                <>
                  {t("Remediated Popup Description")}
                </>
              ) : infoModalType === 3 ? (
                <>
                  {t("Decorative Image Popup Description")}
                </>
              ) : (
                <>

                </>
              )}
            </Modal.Body>
          </Modal>

        </div>

      </DashboardPagesTemplate>

    </>
  )

}

export default ImageAltTextRemediationPage;